import React from 'react';
import { Segmented } from 'antd';
import { EditOutlined, ExperimentOutlined, ControlOutlined } from '@ant-design/icons';
import type { PlanAppMode } from '../../../../types/planManagement';

interface ModeSegmentProps {
  appMode: PlanAppMode;
  disablePlanningMode: boolean;
  disablePlantingMode: boolean;
  disableManagementMode: boolean;
  onAppModeChange: (mode: PlanAppMode) => void;
}

const ModeSegment: React.FC<ModeSegmentProps> = ({
  appMode,
  disablePlanningMode,
  disablePlantingMode,
  disableManagementMode,
  onAppModeChange,
}) => {
  return (
    <Segmented
      value={appMode}
      onChange={onAppModeChange as any}
      options={[
        ...(!disableManagementMode
          ? [{ label: 'Управление', value: 'management', icon: <ControlOutlined /> }]
          : []),
        ...(!disablePlanningMode
          ? [{ label: 'Планирование', value: 'planning', icon: <EditOutlined /> }]
          : []),
        ...(!disablePlantingMode
          ? [{ label: 'Инструменты Pro', value: 'planting', icon: <ExperimentOutlined /> }]
          : []),
      ]}
    />
  );
};

export default ModeSegment;
